import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Refrigerator = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M3.333.643h9.333a1.669 1.669 0 0 1 1.666 1.666v12a1.669 1.669 0 0 1-1.666 1.666H3.333a1.669 1.669 0 0 1-1.667-1.666v-12A1.669 1.669 0 0 1 3.333.643Zm9.333 14.666a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1H3.333a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9.333Z" />
      <path d="M14 7.31H2a.333.333 0 0 1 0-.667h12a.333.333 0 1 1 0 .666ZM4 5.31a.333.333 0 0 1-.334-.334V3.31a.333.333 0 1 1 .667 0v1.666a.333.333 0 0 1-.334.334ZM4 11.643a.333.333 0 0 1-.334-.334V8.976a.333.333 0 1 1 .667 0v2.333a.333.333 0 0 1-.334.334Z" />
    </svg>
  );
};

Refrigerator.category = 'product-category';

Refrigerator.displayName = 'Refrigerator';
